<template>
  <div class="__wrapper">
    <div class="__toolbar">
      <div class="content-wrapper">
        <div class="__logo">
          <img @click="goto('/')" src="../assets/icons/log2.svg" width="156px" />
        </div>
        <div class="__buttons">
          <button class="sign_in_btn" @click="login">Sign In</button>
          <button class="register_btn" @click="signUp">Register</button>
        </div>
      </div>
    </div>

    <div class="helo-section">
      <img class="bg-image" src="@/assets/helo-bg.svg" />
      <div class="slider-widget">
        <div class="slider-item" v-for="(item, index) in slides" :key="index" v-show="item.key == active_slide">
          <div class="services">
            <img :src="require('@/assets/landing/' + item.img)" />
            <ul class="services-list">
              <li :class="{ active: val.key == active_slide }" v-for="(val, i) in slides" :key="i"
                @click="viewService(val.key)">
                {{ val.title | validate }}
              </li>
            </ul>
            <div class="service-def">
              <h3>{{ item.title | validate }}</h3>
              <p>
                {{ item.content | validate }}
              </p>
            </div>
          </div>
          <div class="get-started-section">
            <h1 class="main-title">
              Smart tools for <br />
              successful consultant<br />
              companies
            </h1>
            <button class="btn-get-started" @click="signUp">
              Get Started Now
            </button>
            <h2 class="title-ask">Consultant?</h2>
            <h3 class="join-title" @click="goConsultantNetwork()">
              Join Our <span class="link">Consultant Network Here </span>
              <img src="@/assets/icons/long_right.svg" />
            </h3>
            <h3 class="free-content">It’s free!</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="references-widget" v-if="false">
      <div class="header">
        <!-- <h1>References</h1> -->
      </div>
      <div class="body">
        <div class="item-body">
          <img class="profile" src="@/assets/jonas.jpg" />
          <p>
            “Consultified is unique - first tool that combines all core
            processes in a consultant business with a Consultant Network.”
          </p>
          <div class="info-content">
            <h3 class="names">
              Jonas Luthander,
              <span class="job-title">Ledare Part of Are Group AB</span>
            </h3>
          </div>
        </div>

        <div class="item-body">
          <img class="profile" src="@/assets/vegard.jpg" />
          <p>
            “This is a perfect tool for consultant companies as well as
            consultants around the globe with professional user centered
            features”
          </p>
          <div class="info-content">
            <h3 class="names">
              Vegard Jensvoll,
              <span class="job-title">Yellow Elk AB</span>
            </h3>
          </div>
        </div>
      </div>
    </div>

    <div class="video-intro">
      <div class="body">
        <div class="into-content">
          ”Consultified is unique - first tool that combines all core
          processes<br />
          in a consultant business with a Consultant Network.”
        </div>
      </div>
    </div>

    <div class="earn-widget-section">
      <div class="header">
        <h1>How much would your consulting business earn with Consultified?</h1>
      </div>
      <div class="body">
        <div class="earn-widget">
          <div class="comments-widget" v-if="false">
            <ul>
              <li class="user-comments">
                <img class="profile" src="@/assets/jonas.jpg" />

                <h2 class="title">
                  We get more business and higher utilization rates.
                </h2>
                <p class="content">
                  The time from business opportunity to assignment has decreased
                  from days to hours. The match between skills, assignments and
                  availability has become smoother. With Consultified, we get
                  more and faster business, which increased our utilization rate
                  by several percent.
                </p>
                <div class="info-content">
                  <h3 class="names">
                    Jonas Luthander,
                    <h5 class="job-title">Ledare Part of Are Group AB</h5>
                  </h3>
                </div>
              </li>
              <li class="user-comments">
                <img class="profile" src="@/assets/vegard.jpg" />
                <h2 class="title">
                  We get more business and higher utilization rates.
                </h2>
                <p class="content">
                  Our employees appreciate the social and they gain insight into
                  the business. Available information on assignments and
                  utilization gives us control. Skills, search, and smooth
                  packaging make us save time!
                </p>
                <div class="info-content">
                  <h3 class="names">
                    Vegard Jensvoll,
                    <h5 class="job-title">Yellow Elk AB</h5>
                  </h3>
                </div>
              </li>
            </ul>
          </div>
          <div class="counter-widget">
            <div class="counter-item">
              <h4>Number of Consultant</h4>
              <div class="value-widget">
                <vue-slider v-bind="options_1" v-model="earn_1.consultant" />
                <span class="label">
                  <input class="input" type="number" length="4" min="0" max="2000" v-model="earn_1.consultant" /></span>
              </div>
            </div>
            <div class="counter-item">
              <h4>Hourly fees</h4>
              <div class="value-widget">
                <vue-slider v-bind="options_2" v-model="earn_1.hour" />
                <span class="label">$
                  <input class="input on_hour" type="number" oninput="this.size = this.value.length"
                    v-model="earn_1.hour" />/Hour</span>
              </div>
            </div>
            <div class="counter-item">
              <h4>Higher Utilization</h4>
              <div class="value-widget">
                <vue-slider v-bind="options_3" v-model="earn_1.utilization" />
                <span class="label">
                  <input class="input on_utilization" type="number" v-model="earn_1.utilization" />%</span>
              </div>
            </div>
            <div class="result-widget">
              <h5 class="title">You earn with higher Utilization</h5>
              <p class="price">
                {{
                  $formatMoney(
                    earn_1.consultant * earn_1.hour * earn_1.utilization * 1780,
                    0,
                    ".",
                    ","
                  ) | validate
                }}
                / Year
              </p>
              <h5 class="title">You save with less Administration</h5>
              <p class="price" style="margin-bottom: 0px">
                {{
                  $formatMoney(earn_1.consultant * earn_1.hour * 8, 0, ".", ",")
                  | validate
                }}
                / Year
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="getstarted-widget">
      <div class="header"></div>
      <div class="options">
        <button class="btn-option" @click="login">Sign In</button>
        <span>or</span>
        <button class="btn-option" @click="signUp">Register</button>
      </div>
    </div>

    <div class="contacts-widget">
      <div class="header">
        <h2>Get started with Consultified today!</h2>
        <p>Fill in below and we contact you for a demo or next step.</p>
      </div>
      <div class="body">
        <div class="form-widget">
          <input type="text" placeholder="Company" v-model="contact.company" />
          <input type="text" placeholder="Email" v-model="contact.mail_from" />
          <input type="text" placeholder="Phone" v-model="contact.phone" />
          <c-button :loading="is_contact_loading" class="btn-submit" @click="sendContactMail">
            Contact me
          </c-button>
        </div>
      </div>
    </div>

    <div class="footer-widget">
      <img src="@/assets/icons/log2.svg" />
    </div>
    <div class="home-dialog">
      <template>
        <v-dialog v-model="showContact">
          <v-card color="#D2D1D1">
            <v-layout>
              <div class="cover__body">
                <h2>E-mail</h2>
                <input type="text" v-model="contact.mail_from" />
                <h2>Message</h2>
                <textarea v-model="contact.mail_body"
                  placeholder="If you send us a press inquiry a member of our team will get back to you shortly."></textarea>
                <div class="btns">
                  <button class="ok-btn" @click="sendContactMail">Send</button>
                  <button class="cancel-btn" @click="
                    () => {
                      showContact = false;
                    }
                  ">
                    Cancel
                  </button>
                </div>
              </div>
            </v-layout>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog v-model="showInvestor">
          <v-card color="#D2D1D1">
            <v-layout>
              <div class="cover__body">
                <h2>E-mail</h2>
                <input type="text" v-model="investor.mail_from" />
                <h2>Message</h2>
                <textarea v-model="investor.mail_body"
                  placeholder="If you send us a press inquiry a member of our team will get back to you shortly."></textarea>
                <div class="btns">
                  <button class="ok-btn" @click="sendInvestorMail">Send</button>
                  <button class="cancel-btn" @click="
                    () => {
                      showInvestor = false;
                    }
                  ">
                    Cancel
                  </button>
                </div>
              </div>
            </v-layout>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
export default {
  name: "landing-page",
  components: {
    VueSlider,
  },
  metaInfo: {
    // Children can override the title.
    title: "Welcome to Consultified",
    titleTemplate: "%s",
    // Define meta tags here.
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "title", content: "Welcome to Consultified" },
      {
        name: "description",
        content:
          "Consultified is a platform created by consultants for consultants in order to bridge the gap in the consultant market. By using Consultified, consultants get visibility and enrich their consultant profiles in collaboration with others in the consultant market.",
      },
      // OpenGraph data (Most widely used)
      { property: "og:title", content: "Welcome to Consultified" },
      { property: "og:site_name", content: "Consultified" },
      // The list of types is available here: http://ogp.me/#types
      { property: "og:type", content: "website" },
      // Should the the same as your canonical link, see below.
      {
        property: "og:url",
        content: "https://consultified.com/",
      },
      {
        property: "og:image",
        content: "https://consultified.com/consultified.png",
      },
      // Often the same as your meta description, but not always.
      {
        property: "og:description",
        content:
          "Consultified is a platform created by consultants for consultants in order to bridge the gap in the consultant market. By using Consultified, consultants get visibility and enrich their consultant profiles in collaboration with others in the consultant market.",
      },
      // Twitter card
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "https://consultified.com/",
      },
      { name: "twitter:title", content: "Welcome to Consultified" },
      {
        name: "twitter:description",
        content:
          "Consultified is a platform created by consultants for consultants in order to bridge the gap in the consultant market. By using Consultified, consultants get visibility and enrich their consultant profiles in collaboration with others in the consultant market.",
      },

      {
        name: "twitter:image:src",
        content: "https://consultified.com/consultified.png",
      },
      // Google / Schema.org markup:
      { itemprop: "name", content: "Welcome to Consultified" },
      {
        itemprop: "description",
        content:
          "Consultified is a platform created by consultants for consultants in order to bridge the gap in the consultant market. By using Consultified, consultants get visibility and enrich their consultant profiles in collaboration with others in the consultant market.",
      },
      {
        itemprop: "image",
        content: "https://consultified.com/consultified.png",
      },
    ],
  },
  data() {
    return {
      value: 0,
      options_1: {
        dotSize: 20,
        width: "100%",
        height: 4,
        contained: false,
        direction: "ltr",
        data: null,
        dataLabel: "label",
        dataValue: "value",
        min: 0,
        max: 2000,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: "active",
        tooltipPlacement: "none",
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        dotAttrs: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
      options_2: {
        dotSize: 20,
        width: "100%",
        height: 4,
        contained: false,
        direction: "ltr",
        data: null,
        dataLabel: "label",
        dataValue: "value",
        min: 0,
        max: 2000,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: "active",
        tooltipPlacement: "none",
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        dotAttrs: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
      options_3: {
        dotSize: 20,
        width: "100%",
        height: 4,
        contained: false,
        direction: "ltr",
        data: null,
        dataLabel: "label",
        dataValue: "value",
        min: 0,
        max: 6,
        interval: 1,
        disabled: false,
        clickable: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: "active",
        tooltipPlacement: "none",
        tooltipFormatter: void 0,
        useKeyboard: false,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        dotAttrs: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },
      showTab1: true,
      showTab2: false,
      showContact: false,
      showInvestor: false,
      investor: {
        mail_from: "",
        mail_body: "",
      },
      contact: {
        company: "",
        phone: "",
        mail_from: "",
        mail_body: "Please contact me",
      },
      is_contact_loading: false,
      active_slide: 1,
      slides: [
        {
          title: "Heatmap",
          key: 1,
          img: "heatmap.svg",
          content:
            "Consultified is a tool that helps consultant companies be more effective. You manage your business opportunities, deliveries, projects, competences, recruitment and Sub-contractors. It’s also a Consultant Network.",
        },
        {
          title: "Tasks",
          key: 2,
          img: "tasks.svg",
          content: "Manage your tasks in a effective way. It’s all connected.",
        },
        {
          title: "Leads",
          key: 3,
          img: "leads.svg",
          content:
            "Manage your business opportunities in a effective way. It’s all connected.",
        },
        {
          title: "Candidates",
          key: 4,
          img: "candidates.svg",
          content:
            "Manage your candidates and recruitment process in a effective way. It’s all connected.",
        },
        {
          title: "Accounts",
          key: 5,
          img: "accounts.svg",
          content:
            "Manage your contacts, customers, prospects and partners  in an effective way. It’s all connected.",
        },
        {
          title: "Organisation",
          key: 6,
          img: "organization.svg",
          content:
            "Manage your consultants and organization in an effective way. It’s all connected.",
        },
        {
          title: "Reports",
          key: 7,
          img: "reports.svg",
          content:
            "Visualize your business the way you want. It’s all connected!",
        },
        {
          title: "Skills",
          key: 8,
          img: "skills.svg",
          content:
            "It’s all connected. Your consultants, sub-contractors, partners and candidates skills are managed, searchable and presented in a clever way. You get control and the visibility you always wanted, create resumes or your own or other templates and get the profiles you want googleble.",
        },
      ],
      earn_1: {
        consultant: 100,
        hour: 150,
        utilization: 2,
      },
    };
  },
  methods: {
    goConsultantNetwork() {
      let vm = this;
      vm.$router.push({ name: "signup", query: { type: "consultant" } });
    },
    viewService(key) {
      let vm = this;
      vm.active_slide = key;
    },
    goto(path) {
      this.$router.push({ path: path });
    },
    signUp() {
      this.$router.push({ name: "signup" });
    },
    login() {
      this.$router.push({ name: "login" });
    },
    openForum() {
      window.open("https://forum.consultified.com");
    },
    sendContactMail() {
      let vm = this;
      const rules = {
        company: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Company can not be empty";
          },
        },
        phone: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Phone can not be empty";
          },
        },
        mail_from: {
          run: (value) => {
            if (value) {
              return false;
            } else {
              return "Please add your email";
            }
          },
        },
      };
      if (vm.$isFieldsValidated(vm.contact, rules)) {
        vm.is_contact_loading = true;
        this.contact.mail_body +=
          "\n\n sent from " +
          this.contact.mail_from +
          "\n\n Company: " +
          this.contact.company +
          "\n\n Phone: " +
          this.contact.phone;

        this.$store
          .dispatch("SEND_CONTACT_MAIL", this.contact)
          .then((responce) => {
            vm.is_contact_loading = false;
            vm.contact = {
              company: "",
              phone: "",
              mail_from: "",
              mail_body: "Please contact me",
            };
          })
          .catch((error) => { });
        this.showContact = false;
      }
    },
    sendInvestorMail() {
      this.investor.mail_body += "\n\n sent from " + this.investor.mail_from;
      this.$store.dispatch("SEND_INVESTOR_MAIL", this.investor);
      this.showInvestor = false;
    },
  },
  watch: {
    "earn_1.consultant"(val) {
      let vm = this;
      if (val > 2000) {
        vm.earn_1.consultant = 2000;
      }
    },
    "earn_1.hour"(val) {
      let vm = this;
      if (val > 2000) {
        vm.earn_1.hour = 2000;
      }
    },
    "earn_1.utilization"(val) {
      let vm = this;
      if (val > 6) {
        vm.earn_1.utilization = 6;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$section_padding_left: 60px;
$section_padding_right: 60px;
$section_width: 1250px;

.text-right {
  text-align: right !important;
  font-family: Avenir;
}

.text-center {
  text-align: center !important;
  font-family: Avenir;
}

.__wrapper {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow-y: auto;

  .__toolbar {
    display: flex;
    justify-content: center;
    height: 50px;
    background: linear-gradient(45deg, #1ba5a4, #1885ad);
    padding-top: 10px;
    padding-bottom: 10px;
    z-index: 99999;

    .content-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: $section_width;
      padding-right: $section_padding_right;
      padding-left: $section_padding_left;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
      }

      .__buttons {
        display: flex;

        .sign_in_btn {
          outline: none;
          color: #fff;
          width: 90px;
          height: 35px;
          font-family: Avenir;
          font-size: 14px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          background: transparent;

          @media (min-width: 300px) and (max-width: 630px) {
            width: auto;
          }
        }

        .register_btn {
          width: 90px;
          height: 35px;
          font-family: Avenir;
          font-size: 14px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          border-radius: 0.8vh;
          background-color: #fff;
          color: #00749f;
          outline: none;
          border: none;

          @media (min-width: 300px) and (max-width: 630px) {
            display: none;
          }
        }
      }
    }
  }

  .helo-section {
    position: relative;
    margin-top: unset;

    @media (min-width: 1830px) and (max-width: 3000px) {
      margin-top: -511px;
    }

    @media (min-width: 1500px) and (max-width: 1830px) {
      margin-top: -176px;
    }

    @media (min-width: 300px) and (max-width: 630px) {
      margin-bottom: 100px;
    }

    .bg-image {
      position: relative;
      width: 100%;
      object-fit: cover;
      top: -100px;
      height: 800px;

      @media (min-width: 1830px) and (max-width: 3000px) {
        height: 1400px;
      }

      @media (min-width: 1500px) and (max-width: 1830px) {
        height: 1000px;
      }

      @media (min-width: 300px) and (max-width: 630px) {
        height: 686px;
      }
    }

    .slider-widget {
      position: absolute;
      top: 200px;
      display: flex;
      justify-content: center;
      left: 0px;
      right: 0px;

      @media (min-width: 1830px) and (max-width: 3000px) {
        top: 689px;
      }

      @media (min-width: 1500px) and (max-width: 1830px) {
        top: 353px;
      }

      @media (min-width: 300px) and (max-width: 630px) {
        top: 94px;
      }

      .slider-item {
        display: flex;
        justify-content: space-between;
        width: $section_width;
        padding-right: $section_padding_right;
        padding-left: $section_padding_left;

        @media (min-width: 300px) and (max-width: 630px) {
          flex-direction: column;
          width: 100%;
          padding-left: 20px;
          padding-right: 20px;
        }

        .services {
          width: 53%;
          padding-top: 10px;

          @media (min-width: 300px) and (max-width: 630px) {
            order: 2;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 100%;
            padding-top: 70px;
          }

          img {
            width: 100%;
            max-width: 600px;
            position: relative;
            left: -57px;

            @media (min-width: 300px) and (max-width: 630px) {
              left: unset;
              width: 200px;
            }
          }

          .services-list {
            display: flex;
            list-style: none;
            padding-left: 0px;
            margin-top: 20px;

            li {
              margin-right: 15px;
              font-size: 13px;
              padding: 5px 0px;
              cursor: pointer;

              @media (min-width: 300px) and (max-width: 630px) {
                margin-right: 8px;
                font-size: 10px;
              }

              &.active {
                color: #0884af;
                border-bottom: 4px solid #0884af;
              }
            }
          }

          .service-def {
            padding-left: 0px;
            margin-top: 20px;

            h3 {
              font-size: 800;
              font-size: 25px;
              margin-bottom: 7px;
              font-weight: 800;
              font-family: "AvenirBlack";
            }
          }
        }

        .get-started-section {
          display: flex;
          flex-direction: column;
          align-items: flex-end;

          @media (min-width: 300px) and (max-width: 630px) {
            order: 1;
            justify-content: center;
            align-items: center;
            width: 100%;
          }

          .main-title {
            text-align: right;
            font-size: 50px;
            color: #fff;
            font-family: "AvenirBlack";
            font-weight: 800;
            line-height: 58px;

            @media (min-width: 300px) and (max-width: 630px) {
              text-align: center;
              font-size: 25px;
              line-height: 30px;
            }
          }

          .btn-get-started {
            width: 245px;
            height: 55px;
            background: #fff;
            margin: 33px 0px;
            border-radius: 3px;
            color: #0884af;

            @media (min-width: 300px) and (max-width: 630px) {
              margin: 16px 0px;
            }
          }

          .title-ask {
            text-align: right;
            font-size: 35px;
            color: #fff;
            font-family: "AvenirBook";
            font-weight: 500;
          }

          .join-title {
            display: flex;
            align-items: center;
            color: #fff;

            .link {
              border-bottom: 1px solid #fff;
              margin: 0px 4px;
              font-family: "AvenirBlack";
              font-weight: 800;
              cursor: pointer;
            }

            @keyframes tick {
              from {
                transform: translateX(-10px);
                transition: 1000ms ease-in-out;
                opacity: 0;
              }

              to {
                transform: translateX(0px);
                transition: 1000ms ease-in-out;
                opacity: 1;
              }
            }

            img {
              width: 20px;
              margin-left: 10px;
              animation: tick 1000ms linear infinite;
              cursor: pointer;
            }
          }

          .free-content {
            color: #fff;
            margin-top: 10px;
          }
        }
      }
    }
  }

  .references-widget {
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #f3f2f2;
    padding-bottom: 20px;

    .header {
      padding: 20px 0px;

      h1 {
        font-weight: 800;
        font-family: "AvenirBlack";
      }
    }

    .body {
      width: $section_width;
      padding-right: $section_padding_right;
      padding-left: $section_padding_left;
      display: flex;
      justify-content: space-between;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        padding-right: 20px;
        padding-left: 20px;
        align-items: flex-start;
        flex-direction: column;
      }

      .item-body {
        width: 45%;

        @media (min-width: 300px) and (max-width: 630px) {
          width: 100%;
          margin-bottom: 30px;
        }

        img.profile {
          width: 60px;
          height: 60px;
          object-fit: cover;
          border-radius: 50%;
          margin-bottom: 16px;
        }

        p {
          font-size: 14px;
          font-family: "AvenirBook";
          font-weight: 800;
        }

        .info-content {
          .names {
            font-family: "AvenirBook";
            font-style: normal;
            font-weight: 800;
            display: flex;
            align-items: center;
          }

          .job-title {
            color: rgb(90, 90, 90);
            font-style: normal;
            margin-left: 4px;
          }
        }

        &:nth-child(even) {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          p {
            text-align: left;
            font-size: 14px;
          }

          .info-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
        }
      }
    }
  }

  .video-intro {
    background: #1ba5a4;
    display: flex;
    align-items: center;
    justify-content: center;

    .body {
      display: flex;
      align-items: center;
      justify-content: center;
      width: $section_width;
      padding: 30px 0px;
      padding-right: $section_padding_right;
      padding-left: $section_padding_left;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        padding-right: 20px;
        padding-left: 20px;
        align-items: flex-start;
        flex-direction: column;
      }

      .yt-video {
        width: 50%;

        @media (min-width: 300px) and (max-width: 630px) {
          width: 100%;
        }

        img {
          width: 100%;
          border-radius: 10px;
        }
      }

      .into-content {
        width: 100%;
        font-weight: 800;
        font-size: 23px;
        text-align: center;
        color: #fff;
        font-family: "AvenirBlack";

        @media (min-width: 300px) and (max-width: 630px) {
          width: 100%;
          text-align: center;
        }
      }
    }
  }

  .earn-widget-section {
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #dedede;
    padding-bottom: 30px;

    .header {
      padding: 30px 0px;

      h1 {
        text-align: center;
        font-weight: 800;
        font-family: "AvenirBlack";
      }
    }

    .body {
      width: 100%;
      width: $section_width;
      padding-right: $section_padding_right;
      padding-left: $section_padding_left;
      display: flex;
      flex-direction: column;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        padding-right: 20px;
        padding-left: 20px;
      }

      .earn-widget {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin-bottom: 50px;

        @media (min-width: 300px) and (max-width: 630px) {
          flex-direction: column;
        }

        .comments-widget {
          width: 60%;

          @media (min-width: 300px) and (max-width: 630px) {
            width: 100%;
          }

          ul {
            padding-left: 0px;
            list-style: none;

            li.user-comments {
              margin-bottom: 54px;

              img.profile {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-bottom: 10px;
              }

              .title {
                font-size: 22px !important;
                margin-bottom: 10px;
                font-weight: 800;
                font-family: "AvenirBlack" !important;
              }

              .content {
                font-size: 14px !important;
              }

              p {
                margin: 0px;
              }

              .info-content {
                margin-top: 9px;

                .names {
                  font-family: "AvenirBook";
                  font-style: normal;
                  font-weight: 800;
                  display: flex;
                  align-items: center;
                }

                .job-title {
                  color: rgb(90, 90, 90);
                  font-style: normal;
                  margin-left: 4px;
                }
              }
            }
          }
        }

        .counter-widget {
          background: #fff;
          padding-top: 30px;
          padding-bottom: 15px;
          padding-left: 10px;
          padding-right: 10px;
          border-radius: 5px;
          width: 39%;

          @media (min-width: 300px) and (max-width: 630px) {
            width: 100%;
          }

          &.space {
            margin-right: 30px;
          }

          .counter-item {
            margin-bottom: 25px;
            padding: 0px 30px;

            h4 {
              margin-bottom: 6px;
            }

            .value-widget {
              display: flex;
              position: relative;
              align-items: center;

              .label {
                margin-top: 3px;
                margin-left: 12px;
                width: 80px;
                display: flex;
                align-items: center;

                .input {
                  width: 100%;
                  border: none;
                  outline: none;
                  z-index: 1 !important;

                  &[type="number"] {
                    -moz-appearance: textfield;
                  }

                  &::-webkit-outer-spin-button,
                  &::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                  }

                  &.on_hour {
                    width: 30px;
                  }

                  &.on_utilization {
                    width: 10px;
                  }
                }
              }
            }
          }

          .result-widget {
            background: #eeeeee;
            margin-top: 30px;
            padding: 23px;
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .title {
              font-size: 14px !important;
              margin-bottom: 8px;
              font-family: "Avenir" !important;
              font-weight: 800;
            }

            .price {
              font-size: 18px !important;
              color: #1ba5a4;
            }
          }
        }
      }
    }
  }

  .getstarted-widget {
    background: #fff;
    padding: 70px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      h1 {
        text-align: center;
        font-weight: 800;
        font-size: 40px;
      }
    }

    .options {
      color: #1ba5a4;
      font-weight: 800;
      font-family: "AvenirBlack";
      display: flex;
      align-items: center;

      .btn-option {
        font-size: 30px;
        color: #1ba5a4;
        font-weight: 800;
        font-family: "AvenirBlack";
      }

      span {
        color: #8b8a8a;
        margin: 0px 18px;
        font-size: 24px;
      }
    }
  }

  .contacts-widget {
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #f3f3f3;
    padding-bottom: 70px;

    .header {
      padding: 30px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      h1 {
        text-align: center;
        color: #0884af;
        font-weight: 800;
        font-size: 30px;
        font-weight: 800;
        font-family: "AvenirBlack" !important;
      }

      h2 {
        font-size: 40px;
        color: #707070;
        font-weight: 800;
        margin: 20px 0px;
        text-align: center;

        @media (min-width: 300px) and (max-width: 630px) {
          font-size: 30px;
        }
      }

      p {
        font-size: 17px;
        text-align: center;
      }
    }

    .body {
      display: flex;
      justify-content: center;

      @media (min-width: 300px) and (max-width: 630px) {
        flex-direction: column;
        width: 100%;
        padding-right: 20px;
        padding-left: 20px;
      }

      .form-widget {
        width: 629px;
        display: flex;
        align-items: center;
        flex-direction: column;

        @media (min-width: 300px) and (max-width: 630px) {
          flex-direction: column;
          width: 100%;
        }

        input {
          width: 100%;
          border: 1px solid #cccccc;
          box-sizing: border-box;
          border-radius: 4px;
          height: 45px;
          margin-bottom: 20px;
          padding: 0px 15px;
          outline: none;
          background: #fff;
        }

        .btn-submit {
          width: 100%;
          height: 45px;
          background: #0884af;
          color: #fff;
          border-radius: 4px;
          font-weight: 800;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .footer-widget {
    height: 200px;
    background: linear-gradient(45deg, #1ba5a4, #1885ad);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 17px 0px;

    img {
      width: 150px;
    }
  }
}
</style>

<style lang="scss">
.v-dialog {
  max-width: 400px !important;
}

.vue-slider {
  padding: 2px 0px !important;
  width: auto;
  height: 3px;
  background: #dddddd;

  .vue-slider-dot-handle {
    background-color: #0884af !important;
    border: 2px solid #0884af !important;
  }

  .vue-slider-dot-tooltip-none {
    display: none;
  }
}
</style>
<style lang="scss">
.cover__body {
  padding: 2.8vh;
  width: 100%;

  input {
    height: 5.7vh;
    width: 100%;
    background: #fff;
    font-size: 1.8vh;
    margin: 1.4vh 0;
    font-weight: 300;
    padding: 0 1.4vh;
    outline: none !important;
    border: none !important;
    border-radius: 0.7vh;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;

    &:focus {
      border: none !important;
      outline: none !important;
    }

    &::placeholder {
      opacity: 0.5;
      font-style: italic;
    }
  }

  h2 {
    opacity: 0.51;
    font-family: Avenir;
    font-size: 1.8vh;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #161615;
  }

  textarea {
    height: 17.9vh;
    width: 100%;
    margin: 1.4vh 0;
    border-radius: 0.7vh;
    resize: none;
    padding: 1.4vh;
    background: #fff;
    outline: none;
    font-family: Avenir;
    font-size: 1.8vh;
    font-weight: 300;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: rgba(22, 22, 21, 0.51);

    &::placeholder {
      opacity: 0.5 !important;
      font-style: italic;
    }
  }

  .btns {
    .ok-btn {
      width: 10.3vh;
      height: 3.7vh;
      outline: none;
      opacity: 0.97;
      border-radius: 0.6vh;
      font-family: Avenir;
      font-size: 1.5vh;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      background-image: linear-gradient(to right,
          #1d9694 0%,
          #199295 36%,
          #108798 68%,
          #01759e 98%,
          #00749f 100%);
    }

    .cancel-btn {
      width: 10.3vh;
      height: 3.7vh;
      outline: none;
      opacity: 0.51;
      font-family: Avenir;
      font-size: 1.5vh;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #161615;
    }
  }
}</style>



